import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { api } from '../api/client'
import { CONNECTORS } from '../connectors'
import { ROUTES } from '../routes'
import ConnectorHub from './ConnectorHub'

// Маршрут /integrations/:slug — хаб коннектора. Сюда же ведут открытие из
// Маркетплейса (claim в hash), OAuth-возврат и старые ссылки с ?legacy=1.
// Неизвестный slug → «Коннектор не найден» (критерий приёмки).
export default function ConnectorSetup () {
  const { slug } = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const entry = CONNECTORS[slug]
  const claimToken = slug === 'bitrix24'
    ? new URLSearchParams(location.hash.replace(/^#/, '')).get('marketplace_claim')
    : null
  const [claimStatus, setClaimStatus] = useState(claimToken ? 'loading' : 'idle')
  const [claimAttempt, setClaimAttempt] = useState(0)
  // Портал, который занят сейчас: приходит в 409 и позволяет назвать его
  // вместо общего «ссылка могла устареть».
  const [busyPortal, setBusyPortal] = useState(null)

  const clearClaimHash = () => {
    const hash = new URLSearchParams(location.hash.replace(/^#/, ''))
    hash.delete('marketplace_claim')
    navigate({
      pathname: location.pathname,
      search: location.search,
      hash: hash.toString() ? `#${hash.toString()}` : ''
    }, { replace: true })
  }

  useEffect(() => {
    if (!claimToken) {
      setClaimStatus('idle')
      return
    }

    let active = true
    setClaimStatus('loading')
    api.claimBitrix24Connection(claimToken)
      .then(() => {
        if (!active) return
        clearClaimHash()
        setClaimStatus('idle')
      })
      .catch(err => {
        if (!active) return
        // 409 — не «устаревшая ссылка», а занятый портал: показываем причину
        // и даём сменить его одним подтверждением.
        if (err?.status === 409 && err?.portal) {
          setBusyPortal(err.portal)
          setClaimStatus('conflict')
          return
        }
        setClaimStatus('error')
      })

    return () => { active = false }
  }, [claimToken, claimAttempt, location.hash, location.pathname, location.search, navigate])

  if (!entry) {
    return (
      <div style={s.notFound}>
        <div style={s.notFoundTitle}>Коннектор не найден</div>
        <Link to={ROUTES.INTEGRATIONS} style={s.link}>← Интеграции</Link>
      </div>
    )
  }

  if (claimStatus === 'loading') {
    return <div style={s.claimState}>Подключаем Bitrix24…</div>
  }

  if (claimStatus === 'conflict') {
    return (
      <div role='alert' style={s.claimError}>
        <div>К вашему аккаунту подключён портал {busyPortal}. Чтобы подключить новый, нужно отключить текущий.</div>
        <div>Сопоставления сотрудников и контрагентов портала {busyPortal} сохранятся — при возврате к нему они восстановятся.</div>
        <button
          type='button'
          style={s.retryBtn}
          onClick={() => {
            setClaimStatus('loading')
            api.replaceBitrix24Portal(claimToken)
              .then(() => {
                clearClaimHash()
                setClaimStatus('idle')
              })
              .catch(() => setClaimStatus('error'))
          }}
        >
          Отключить {busyPortal} и подключить новый
        </button>
      </div>
    )
  }

  if (claimStatus === 'error') {
    return (
      <div role='alert' style={s.claimError}>
        <div>Не удалось завершить подключение из Bitrix24. Ссылка могла устареть.</div>
        <button type='button' style={s.retryBtn} onClick={() => setClaimAttempt(value => value + 1)}>
          Повторить
        </button>
      </div>
    )
  }

  return <ConnectorHub />
}

const s = {
  notFound: { textAlign: 'center', padding: 48 },
  notFoundTitle: { fontSize: 18, fontWeight: 600, color: '#0D2137', marginBottom: 16 },
  link: { color: '#0E4D72', fontSize: 14, textDecoration: 'none', fontWeight: 500 },
  claimState: { padding: 32, color: '#64748B', fontSize: 14 },
  claimError: { margin: '24px 0', padding: 16, borderRadius: 8, background: '#FEF2F2', color: '#B91C1C', fontSize: 14 },
  retryBtn: { marginTop: 12, border: 0, borderRadius: 6, padding: '8px 14px', background: '#0E4D72', color: '#fff', cursor: 'pointer' }
}
